module.exports = __webpack_public_path__ + "img/at.49120c5f.svg";